import cloneDeep from 'lodash.clonedeep';
import types from './actionTypes';
import networks from '../../../test/user_triggers'


const initialState = []
// const initialState = networks;


export default function appReducer(state = initialState, action) {
  // console.log("----action----", action)
  switch (action.type) {
    case types.ADD_USER_TRIGGER: {
      return [
        ...state,
        action.payload
      ]
    }

    case types.EDIT_USER_TRIGGER: {
      return [...state.map(userTrigger => userTrigger.id == action.payload.id ? (action.payload) : ({ ...userTrigger }))]
    }

    case types.DELETE_USER_TRIGGER: {
      return state.filter(userTrigger => userTrigger.id !== action.payload.id)
    }

    case types.UPDATE_FULL_USER_TRIGGERS: {
      return [
        ...state,
        ...action.payload
      ]
    }

    case types.RESET_USER_TRIGGERS: {
      return [
        // ...state,
        ...action.payload
      ]
    }

    case types.UPDATE_REORDERED_USERTRIGGERS: {

      return [...action.payload]
    }

    case 'RESET_BLUEPRINT':
      return cloneDeep(initialState);

    default:
      return state;
  }
}